<template>
  <div
    class="h-full"
    :class="{ 'my-account-scroll-area-mobile': !isDesktop }"
  >
    <!-- :settings="settings" -->
    <!-- :settings="settings" -->
    <!-- <h3 class="message-flags mt-5">
      
    </h3> -->
    <vx-card
      :title="$t('USER_NOTIFICATION').Block_notifications"
      class="mb-5"
    >
      <p class="mt-3 ml-5 block-notifications" :class="{'mt-3': isDesktop}"> 
        <span class="tit-not">{{ $t("USER_NOTIFICATION").Not_Receive_Email }}</span>
        <vs-switch class="switch-option"  v-model="notSendEmailNotification" @click="!isDesktop && onSubmit()"/>
      </p>
      <p class="mt-3 ml-5 mb-5 block-notifications" :class="{'mt-3': isDesktop}"> 
       <span class="tit-not">{{ $t("USER_NOTIFICATION").Not_Receive_Push }}</span>
        <vs-switch class="switch-option"  v-model="notSendPushNotification" @click="!isDesktop && onSubmit()" /></p>
    </vx-card>
    <vx-card class="content-signature p-5" id="content-signature">
      
      <!-- <p class="mb-4">Configure e depois salva suas preferências.</p> -->
      <h4 class="message-flags mb-5">
        {{ $t("USER_NOTIFICATION").Subtitle }}
      </h4>
      <vs-button color="primary" class="mt-2 btn-save-not" @click="onSubmit" style="min-width: 60px; z-index: 2; bottom: 15px;" v-if="isDesktop">{{
        $t("BUTTONS").Save
      }}</vs-button>
      
      
      <vs-row vs-w="12">
        <vs-collapse>
          <vs-collapse-item v-for="(item, index) in signatures" :key="index">
            <div slot="header" class="flex">
              <div class="vx-col sm:w-1/1 w-full name-commoditie"><b>{{ item.name }}</b></div>
              <div class="flex">
                <div class="colum-switch">
                 <label class="lbl-not"> {{ $t("USER_NOTIFICATION").Email }}</label>
                  <vs-switch
                    @click.stop
                    v-model="item.emailAll"
                    @change="selectAllEmail(item.id)"
                    :disabled="notSendEmailNotification"
                    @click="!isDesktop && onSubmit()"
                  />
                </div>
                <div class="">
                  
                </div>
                <div class="colum-switch">
                  <label class="lbl-not"> {{ $t("USER_NOTIFICATION").Push }}</label>

                  <vs-switch
                    @click.stop
                    v-model="item.pushAll"
                    @change="selectAllPush(item.id)"
                    :disabled="notSendPushNotification"
                    @click="!isDesktop && onSubmit()"
                  />
                </div>              
              </div>
            </div>
            <!-- First line column header -->
            <vs-col vs-type="flex" vs-lg="12" vs-sm="12" vs-xs="12">
              <div class="vx-col sm:w-1/1 w-full">
                <div class="lbl-not">
                  {{ $t("USER_NOTIFICATION").Content }}
                </div>
              </div>

              <div class="header-actions">
                <div class="lbl-not">
                  {{ $t("USER_NOTIFICATION").Email }}
                </div>
              </div>
              <div class="header-actions">
                <div class="lbl-not">
                  {{ $t("USER_NOTIFICATION").Push }}
                </div>
              </div>
            </vs-col>
           
           <!-- Contents Line -->
            <vs-col
              vs-type="flex"
              vs-lg="12"
              vs-sm="12"
              vs-xs="12"
              v-for="(content, index) in item.contents"
              :key="index"
              class="line-notifications"
            >
              <div class="vx-col sm:w-1/1 w-full">
                <span class="name-notification">{{ content.name }}</span>
              </div>
              <div class="colum-switch email">
                <vs-switch v-model="content.email" v-if="!isContentNews(content)" :disabled="checkContentEmailDisable(content)" @click="changeValueEmail(item, content, content.email); !isDesktop && onSubmit()"  />
                <div v-if="isContentNews(content)" style="width: 40px;text-align: center;line-height: 21px;font-weight: bold;">-</div>
              </div>
              <div class="colum-switch">
                <vs-switch
                  v-model="content.push"
                  :disabled="notSendPushNotification"
                  @click="changeValuePush(item, content, content.push); !isDesktop && onSubmit()"
                />
              </div>
            </vs-col>
          </vs-collapse-item>
        </vs-collapse>
      </vs-row>
      
    </vx-card>
    <div v-if="!isDesktop" class="v-nav-menu-swipe-area" v-hammer:swipe.right="onClose"></div>
  </div>
</template>

<script>
import AppConstants from "../../appConstants";
import messagesNotifyHelper from "../../helpers/messages-notify-helper";
import userService from "../../providers/userService";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from "vue-select";
import Flags from "../../components/translate/Flags";
import { EventBus } from "../../event-bus";
import { CONTENT } from "../../enums/enum-content";

export default {
  components: {
    VuePerfectScrollbar,
    vSelect,
    Flags
  },
  created() {
    EventBus.$emit(
      AppConstants.BUS_EVENT_HEADER_MOBILE_TITLE,
      this.$t("MY_ACCOUNT").Title
    );
  },
  data() {
    return {
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3,
        swipeEasing: true
      },
      signatures: [],
      notSendEmailNotification: false,
      notSendPushNotification: false
    };
  },
  computed: {
    isDesktop() {
      return this.$store.state.isDesktop;
    },
    getTitle() {
      return this.isDesktop ? "" : this.$t("MY_ACCOUNT").Title;
    }
  },
  watch: {
    "$i18n.locale"() {
      // userService.updateUser(new URLSearchParams(), {language: getLocaleCode(locale)});
      // multi language - when change value request new data from server
      // this.form.language = getLocaleCode(locale);
      // this.loadData(false);
      this.loadUserData();
    }
  },
  methods: {
    changeValuePush(item, content, value) {
      const i = this.signatures.findIndex(s => s.id == item.id);
      if (i >= 0) {
        if (!value) {
          this.signatures[i].contents[this.signatures[i].contents.findIndex(c => c.id == content.id)].pushAll = false;
        } else {
          // if (this.signatures[i].contents.findIndex(c => !c.push) >= 0) this.signatures[i].pushAll = false;
          // else this.signatures[i].pushAll = true;
          let canSelectAllPush = true;
          for (let index = 0; index < this.signatures[i].contents.length; index++) {
            if (!this.signatures[i].contents[index].push) canSelectAllPush = false;
          }
          this.signatures[i].pushAll = canSelectAllPush;
        }
      }
    },
    changeValueEmail(item, content, value) {
      const i = this.signatures.findIndex(s => s.id == item.id);
      if (i >= 0) {
        if (!value) {
          this.signatures[i].contents[this.signatures[i].contents.findIndex(c => c.id == content.id)].emailAll = false;
        } else {
          // if (this.signatures[i].contents.findIndex(c => !c.push) >= 0) this.signatures[i].pushAll = false;
          // else this.signatures[i].pushAll = true;
          let canSelectAllEmail = true;
          for (let index = 0; index < this.signatures[i].contents.length; index++) {
            if (!this.signatures[i].contents[index].email) canSelectAllEmail = false;
          }
          this.signatures[i].emailAll = canSelectAllEmail;
        }
      }
    },
    onClose() {
      this.$emit('close');
    },
    isContentNews(content) {
      return content.code == CONTENT.NEWS;
    },
    checkContentEmailDisable(content) {
      return this.notSendEmailNotification || this.isContentNews(content);
    },
    selectAllEmail(subjectId) {
      const sIndex = this.signatures.findIndex(item => item.id == subjectId);
      if (sIndex >= 0) {
        for (
          let index = 0;
          index < this.signatures[sIndex].contents.length;
          index++
        ) {
          if (this.signatures[sIndex].emailAll) {
            this.signatures[sIndex].contents[index].email = true;
          } else {
            this.signatures[sIndex].contents[index].email = false;
          }
        }
      }
    },
    selectAllPush(subjectId) {
      const sIndex = this.signatures.findIndex(item => item.id == subjectId);
      if (sIndex >= 0) {
        for (
          let index = 0;
          index < this.signatures[sIndex].contents.length;
          index++
        ) {
          if (this.signatures[sIndex].pushAll) {
            this.signatures[sIndex].contents[index].push = true;
          } else {
            this.signatures[sIndex].contents[index].push = false;
          }
        }
      }
    },
    getContentName(item) {
      return item[`name${this.$i18n.locale}`];
    },
    // loadData(loadUserData) {
    //   Promise.all([
    //     contentService.getContentNotification(new URLSearchParams()),
    //   ]).then(res => {
    //       this.content = res[0];
    //       if (loadUserData) {
    //         this.loadUserData();
    //       }
    //       // console.log(this.content);
    //     })
    //     .catch(error => console.log(error));
    // },
    loadUserData() {
      this.$vs.loading({
        container: "#content-signature",
        scale: 0.6
      });
      userService
        .getUserNotification(new URLSearchParams())
        .then(data => {
          // this.languages = data.listLanguage;
          // this.country = data.listCountry;

          this.signatures = data.subjects.map(item => {
            let canSelectAllEmail = true;
            let canSelectAllPush = true;
            for (let index = 0; index < item.contents.length; index++) {
              if (!item.contents[index].email) canSelectAllEmail = false;
              if (!item.contents[index].push) canSelectAllPush = false;
            }
            item.emailAll = canSelectAllEmail;
            item.pushAll = canSelectAllPush;
            return item;
          });
          this.notSendEmailNotification = data.notSendEmailNotification;
          this.notSendPushNotification = data.notSendPushNotification;
          
          setTimeout(() => {
            this.$vs.loading.close("#content-signature > .con-vs-loading");
          }, 200);
        })
        .catch(error => console.log(error));
    },
    onSubmit() {
    console.log("CAIU AQUI")
      const form = {
        subjects: JSON.parse(JSON.stringify(this.signatures)),
        notSendEmailNotification: this.notSendEmailNotification,
        notSendPushNotification: this.notSendPushNotification
      };
      userService
        .updateUserNotification(new URLSearchParams(), form)
        .then(() => {
          messagesNotifyHelper.successNotify(
            this.$t("MY_ACCOUNT").Notify_Success_Title,
            this.$t("MY_ACCOUNT").Notify_Success_Message
          );
        })
        .catch(error => console.log(error));
    },
    onBack() {
      EventBus.$emit(AppConstants.BUS_EVENT_OPEN_USER_MENU_MOBILE);
      this.$router.back();
    }
  },
  mounted() {
    EventBus.$on(AppConstants.BUS_EVENT_HEADER_MOBILE_BACK, () => {
      this.onBack();
    });
    this.loadUserData();
  },
  beforeDestroy() {
    EventBus.$off(AppConstants.BUS_EVENT_HEADER_MOBILE_BACK);
  }
};
</script>

<style lang="scss">
#user-email-config {
  h5 {
    margin-bottom: 10px;
  }
  .vs-col {
    margin-top: 6px;
  }
  .input-switch {
    align-self: center;
  }
}

.row-btn {
  margin: 10px 0px;
}
.custom-scroll-content-my-account {
  height: calc(100% - 100px);
}
.my-account-help-language {
  margin-left: 10px;
}
.required-field {
  margin-left: 2px;
  color: red;
}

.theme-dark {
  .vs__clear {
    background-color: #363c42 !important;
  }
  .vs__open-indicator {
    background-color: #363c42 !important;
  }
}
#my-account-scroll {
  #flags {
    float: left;
  }
}
.vs-collapse-item.open-item {
  background-color: #efefef;
  border: 1px solid #ddd;
  padding-bottom: 5px;
  line-height: 16px;
  border-radius: 3px;
  margin-top: 10px;
}
</style>
